<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->
<template>
  <div class="view__movement">
    <div class="view__movement__inner">
      <ErrorBox
        :title="title"
        :logo="false"
        message="Se resultater for:">

        <ul>
          <li v-for="m in movements" :key="m.id">
            <router-link :to="link(m.id, year)">{{ m.name }} {{ year }}</router-link>
          </li>
        </ul>

      </ErrorBox>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.view__movement {
  ul {
    text-align: left;
  }

  li {
    padding: 0.5em;
  }
}
</style>

<script>
import ErrorBox from '../components/ErrorBox.vue'
import { mapGetters } from 'vuex'

export default {
  props: {
    year: Number,
    county: Object,
    municipality: Object
  },

  components: {
    ErrorBox
  },

  computed: {
    ...mapGetters([
      'countyById',
      'municipalityById',
      'allMovements'
    ]),

    movement () {
      return this.allMovements[this.$route.query.movement]
    },

    title () {
      /* eslint-disable camelcase */

      const movement = this.movement
      const type = movement.type === 1 ? 'fylke' : 'kommune'

      return `${movement.name} ${type} ble først opprettet i ${movement.changed_year}.`
    },

    movements () {
      /* eslint-disable camelcase */
      const move = this.movement

      return move
        .merged_legacy_ids
        .map(id => {
          return move.type === 1
            ? this.countyById(id)
            : this.municipalityById(id, this.year)
        })
    }
  },

  methods: {
    link (id, year) {
      const movement = this.movement

      return movement.type === 1
        ? this.countyLink(id, { year, redirected: true })
        : this.municipalityLink(id, { year, redirected: true })
    }
  }
}
</script>
